import { Button } from "@mui/material";
import React from "react";

interface IPortalButtonProps {
  /** The zip code to which the call center portal should be opened. */
  zipCode: string;
}

/** A Portal Button that needs the Customer Zip Code. */
const IntroPortalButton: React.FC<IPortalButtonProps> = ({ zipCode }) => (
  <Button onClick={() => window.open(`https://callcenter.sonobello.com/?zip=${zipCode}`)}>Open</Button>
);

export default IntroPortalButton;
